mutation updateSavedContentBatch($input: UpdateSavedContentBatchInput!) {
  updateSavedContentBatch(input: $input)
}
